import type { FleetSummary, SetupStatus } from '@mervonn/shared-types';
import { apiList, apiRequest } from '../../lib/api/client';

/** Stage 7 Phase 2A — the shell's header: search, notification inbox, sync pill. */

export interface SearchEmployee {
  employee_id: string;
  employee_number: string;
  name: string;
  job_title: string | null;
  status: string;
}
export interface SearchDevice {
  device_id: string;
  name: string;
  serial_number: string;
  status: string;
}
export interface InboxItem {
  inbox_id: string;
  event_type: string;
  title: string;
  body: string;
  created_at: string;
  read_at: string | null;
}

export const shellApi = {
  searchEmployees: (q: string) => apiRequest<SearchEmployee[]>('/search/employees', { query: { q } }),
  searchDevices: (q: string) => apiRequest<SearchDevice[]>('/search/devices', { query: { q } }),
  inbox: () => apiList<InboxItem>('/notifications/inbox', { query: { limit: 20 } }) as unknown as Promise<{
    data: InboxItem[];
    meta: { unread: number };
  }>,
  inboxPage: (page: number, perPage: number) =>
    apiList<InboxItem>('/notifications/inbox', { query: { page, per_page: perPage } }) as unknown as Promise<{
      data: InboxItem[];
      meta: { unread: number; page: number; per_page: number; total: number };
    }>,
  unreadCount: () => apiRequest<{ unread: number }>('/notifications/inbox/unread-count'),
  markRead: (id: string) => apiRequest(`/notifications/inbox/${id}/read`, { method: 'POST' }),
  markAllRead: () => apiRequest('/notifications/inbox/read-all', { method: 'POST' }),
  setupStatus: () => apiRequest<SetupStatus>('/tenant/setup-status'),
  fleetSummary: () => apiRequest<FleetSummary>('/devices/fleet-summary'),
};
